export class ChangedFlag {
    private initialState: KnockoutObservable<string>;
    private root: KnockoutObservable<any>;
    public isChanged: KnockoutComputed<boolean>;

    public constructor(root: KnockoutObservable<any>) {
        this.root = root;
        this.initialState = ko.observable(ko.toJSON(this.root));

        let changedFlagResult = this;
        this.isChanged = ko.computed(function () {
            return changedFlagResult.initialState() !== ko.toJSON(changedFlagResult.root);
        });
    }

    public reset() {
        this.initialState(ko.toJSON(this.root));
    }
}